import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";

const config = {
  apiKey: "AIzaSyADxZ_gsKKfBJl3W41nZVZpaKM8qBpet8E",
  authDomain: "dice-room-efef4.firebaseapp.com",
  databaseURL: "https://dice-room-efef4.firebaseio.com",
  projectId: "dice-room-efef4",
  storageBucket: "dice-room-efef4.appspot.com",
  messagingSenderId: "1079321957109",
  appId: "1:1079321957109:web:152c016e60f57220cd2bbc",
  measurementId: "G-829V66EPJ1"
};

// firebase utils
firebase.initializeApp(config);

const firestore = firebase.firestore();
const database = firebase.database();

// firebase collections
const usersCollection = firestore.collection("users");
const roomsCollection = firestore.collection("rooms");
const eventsCollection = firestore.collection("events");

export {
  firestore,
  database,
  usersCollection,
  roomsCollection,
  eventsCollection
};
